import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Alert from '@zimpel/common/components/Alert/Alert';
import { BigBlock, SmallBlock } from '@zimpel/common/components/Blocks';
import { PrimaryButton } from '@zimpel/common/components/Buttons';
import { GridCol, GridRow } from '@zimpel/common/components/Grid';
import { H2 } from '@zimpel/common/components/Headlines';
import Label from '@zimpel/common/components/Label';
import PasswordField from '@zimpel/common/components/PasswordField';
import t from '@zimpel/common/helpers/i18n';
import useHandleErrors from '@zimpel/common/hooks/useHandleErrors';
import useHandleValidationErrors from '@zimpel/common/hooks/useHandleValidationErrors';
import { useNotificationContext } from '@zimpel/AppContext';
import { updatePassword } from './api';
import Layout from './Layout';

const PasswordNew = () => {
  const { notifySuccess } = useNotificationContext();
  const [globalError, setGlobalError] = useState<string | undefined>(undefined);
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const handleValidationErrors = useHandleValidationErrors();
  const handleErrors = useHandleErrors();

  if (!token) {
    return null;
  }

  return (
    <Layout>
      <GridRow>
        <GridCol $width={10} $padLeft={2}>
          <H2>{t('authentication.new_password.header')}</H2>
          {globalError && <Alert $type="error">{globalError}</Alert>}

          <Formik
            onSubmit={async (values, { setErrors }) => {
              const { password, passwordConfirmation } = values;
              handleErrors(async () => {
                const [, validationErrors] = await handleValidationErrors({ setErrors }, async () => {
                  await updatePassword({ password, passwordConfirmation, token });
                  notifySuccess(t('authentication.new_password.success_msg'));
                  navigate('/login');
                });

                if (validationErrors && validationErrors.notFound) {
                  setGlobalError(t('authentication.new_password.invalid_token_error'));
                }
              });
            }}
            initialValues={{
              password: '',
              passwordConfirmation: '',
            }}
          >
            {({ isSubmitting }) => (
              <SmallBlock>
                <Form>
                  <Label htmlFor="password">
                    {t('authentication.new_password.label')}
                  </Label>
                  <PasswordField id="password" name="password" required />
                  <SmallBlock>
                    <Label htmlFor="password-confirmation">
                      {t('authentication.password_confirmation.label')}
                    </Label>
                    <PasswordField id="password-confirmation" name="passwordConfirmation" required />
                  </SmallBlock>

                  <BigBlock>
                    <PrimaryButton disabled={isSubmitting} $width="s" $height="l" type="submit">
                      {t('authentication.send_button')}
                    </PrimaryButton>
                  </BigBlock>
                </Form>
              </SmallBlock>
            )}
          </Formik>

        </GridCol>
      </GridRow>
    </Layout>
  );
};

export default PasswordNew;
